module.exports = "<div class=\"container-fluid\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-6\">\n        <router-outlet></router-outlet>\n      </div>\n      <div class=\"col-6 background\"></div>\n    </div>\n  </div>\n</div>\n\n<lowy-toast></lowy-toast>"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.html
// module id = ./src/app/login/login.component.html
// module chunks = main